import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import type { Action } from 'modules/automations/store/models/Action'

import { Bar } from './Bar'
import { ActionStepHeader } from './header'
import styles from './index.module.css'
import { AutomationStepType } from './types'

interface Props {
  action?: Action
  disabled?: boolean
  title: string
  onClick?: (event: React.SyntheticEvent) => void
  stepType: AutomationStepType
  trigger?: string
  withLastSpacer?: boolean
  conflict?: boolean
}

const cx = classNames.bind(styles)

export const AutomationStep = ({
  action,
  disabled = false,
  title,
  onClick,
  stepType,
  trigger,
  withLastSpacer = false,
  conflict,
  children,
}: React.PropsWithChildren<Props>) => {
  const [open, toggle] = useToggle()

  function renderPlus() {
    if (!onClick) return null

    return (
      <div className={styles.plus}>
        {!(disabled && !withLastSpacer) && <div className={styles.plusSpacer} />}
        {!disabled && (
          <div className={styles.plusSign}>
            <Button onClick={onClick} type="secondary" iconName="add" />
          </div>
        )}
        {withLastSpacer && <div className={styles.plusSpacer} />}
      </div>
    )
  }

  return (
    <div className={styles.step}>
      <span className={cx('banner', stepType)} />
      <div className={styles.stepContent}>
        <ActionStepHeader
          action={action}
          disabled={disabled}
          stepType={stepType}
          trigger={trigger}
          title={title}
          conflict={conflict}
        />
        {children && (
          <div className={styles.body}>
            <Bar open={open} onClick={toggle(!open)} />
            {open && children}
          </div>
        )}
      </div>
      {renderPlus()}
    </div>
  )
}
